import React, { useState, useMemo, useEffect } from 'react';
import find from 'lodash/find';
import assign from 'lodash/assign';
import classnames from 'classnames';

import config from './config.json';

import styles from './styles.scss';

const Headshot = props => {
  const {
    amp,
    candidate,
    type,
    blackWhite,
    party: overrideParty,
    size: sizeName,
  } = props;

  const noCache = props['no-cache'];
  const width = props['amp-width'];

  let candidateData = find(config.candidates, { uid: candidate });
  if (!candidateData) {
    candidateData = find(config.candidates, { fecid: candidate });
  }
  if (!candidateData) {
    candidateData = find(config.candidates, { slug: candidate });
  }
  if (!candidateData) {
    candidateData = find(config.candidates, { name: candidate });
  }
  if (!candidateData) {
    return null;
  }

  const [format, setFormat] = useState(amp ? 'webp' : null);

  const [src, fallbackSrc, webpSrc] = useMemo(() => {
    const root = noCache ? config.direct_root : config.root;

    const src = `${root}${format}/${config.sizes[sizeName]}/${candidateData.slug}.${format}`;
    const fallbackSrc = `${root}png/${config.sizes[sizeName]}/${candidateData.slug}.png`;
    const webpSrc = `${root}webp/${config.sizes[sizeName]}/${candidateData.slug}.webp`;

    if (!format) {
      return [null, fallbackSrc, webpSrc];
    }

    return [src, fallbackSrc, webpSrc];
  }, [noCache, format]);

  const party = useMemo(
    () => overrideParty || candidateData.party,
    [overrideParty, candidateData.party]
  );

  const alt = useMemo(
    () => `${candidateData.name} 2020 election candidate`,
    [candidateData.name]
  );

  const className = useMemo(
    () => `BW-${blackWhite}`,
    [blackWhite]
  );

  const height = useMemo(
    () => {
      if (!width) { return width; };
      return width * 11 / 10;
    },
    [width]
  );

  useEffect(() => {
    const test = new Image();

    test.onload = function() {
      var result = (test.width > 0) && (test.height > 0);
      if (result) {
        setFormat('webp');
      } else {
        setFormat('png');
      }
    };

    test.onerror = function(e, a) {
      setFormat('png');
    };

    test.src = webpSrc;
  }, []);

  return (
    <div className={classnames('headshot-container', styles.styles)}>
      <div className='border-container'>
        <div className={`background type-${type} party-${party}`} />
        {src && amp &&
          <amp-img
            layout='responsive'
            className={className}
            alt={alt}
            src={src}
            width={width ? width.toString() : null}
            height={height ? height.toString() : null}
          >
            <amp-img
              src={fallbackSrc}
              layout='responsive'
              className={className}
              alt={alt}
              width={width ? width.toString() : null}
              height={height ? height.toString() : null}
            />
          </amp-img>
        }

        {src && !amp &&
          <img
            src={src}
            className={className}
            alt={alt}
          />
        }
      </div>
    </div>
  );
};

Headshot.defaultProps = {
  'no-cache': false,
  candidate: null, // format is firstname-lastname all lowercase, no punctuation
  type: 'solid', // ['solid', 'outline', 'none']
  blackWhite: 'false', // ['true', 'false']
  party: null, // ['dem', 'gop', 'ind']
  size: 'md', // ['sm', 'md', 'lg']
  amp: false,
  'amp-width': null, // A width size for amp
};

export default Headshot;
